// jQuery free
import LZString from 'lz-string';

export function getVehicleSelectionVehicleBrands(vehicleType, dataOrigins = null) {
    const params = new URLSearchParams({ vehicleType });
    if (dataOrigins && Array.isArray(dataOrigins) && dataOrigins.length > 0) {
        dataOrigins.forEach(origin => params.append('dataOrigins[]', origin));
    }
    const cacheKey = `${vehicleType}-${dataOrigins ? dataOrigins.join(',') : ''}`;
    return sessionStorageCachedAjaxGet('/api/vehicle/vehicle-selection/vehicle-brands', params, cacheKey);
}


export function getVehicleSelectionVehicleModels(vehicleType, vehicleBrandId, dataOrigins = null) {
    const params = new URLSearchParams({
        vehicleType,
        vehicleBrandId
    });
    if (dataOrigins && Array.isArray(dataOrigins) && dataOrigins.length > 0) {
        dataOrigins.forEach(origin => params.append('dataOrigins[]', origin));
    }
    const cacheKey = `${vehicleType}-${vehicleBrandId}-${dataOrigins ? dataOrigins.join(',') : ''}`;
    return sessionStorageCachedAjaxGet('/api/vehicle/vehicle-selection/vehicle-models', params, cacheKey);
}


export function getVehicleSelectionVehicleMotorizations(vehicleType, vehicleBrandId, vehicleModelId, dataOrigins = null) {
    const params = new URLSearchParams({
        vehicleType,
        vehicleBrandId,
        vehicleModelId
    });
    if (dataOrigins && Array.isArray(dataOrigins) && dataOrigins.length > 0) {
        dataOrigins.forEach(origin => params.append('dataOrigins[]', origin));
    }
    const cacheKey = `${vehicleType}-${vehicleBrandId}-${vehicleModelId}-${dataOrigins ? dataOrigins.join(',') : ''}`;
    return sessionStorageCachedAjaxGet('/api/vehicle/vehicle-selection/vehicle-motorizations', params, cacheKey);
}

export function postVehicleSelectionUnselect() {
    return fetch('/api/vehicle/vehicle-selection/vehicle-unselect', {
        method: 'POST',
        mode: 'same-origin', // send cookies _nss for isSameSite()
        headers: {
            'X-Requested-With': 'XMLHttpRequest' // To force Nette isAjax() to be true.
        }
    });
}


function sessionStorageCachedAjaxGet(url, requestData, storageKeySuffix = '') {
    const storageKey = LZString.compressToUTF16('GET' + url + storageKeySuffix);

    const requestDataObj = requestData instanceof URLSearchParams
        ? Object.fromEntries(requestData)
        : requestData;

    const storageValue = sessionStorage.getItem(storageKey);
    if (storageValue) {
        const value = JSON.parse(LZString.decompressFromUTF16(storageValue));
        if (JSON.stringify(value.requestData) === JSON.stringify(requestDataObj)) {
            return Promise.resolve(value.responseData);
        }
        sessionStorage.removeItem(storageKey);
    }

    const queryString = requestData instanceof URLSearchParams
        ? requestData.toString()
        : new URLSearchParams(requestData).toString();
    const fetchUrl = url + '?' + queryString;

    return fetch(fetchUrl, {
        method: 'GET'
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`API request failed with status ${response.status}`);
            }
            return response.json();
        })
        .then(responseData => {
            const storageValue = LZString.compressToUTF16(JSON.stringify({requestData: requestDataObj, responseData}));
            sessionStorage.setItem(storageKey, storageValue);
            return responseData;
        });
}
